"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoiceMessage = void 0;
var lite_1 = __importDefault(require("mime/lite"));
var path_1 = __importDefault(require("path"));
var react_1 = __importStar(require("react"));
var VoiceMessage = function (props) {
    var audioRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        audioRef.current.addEventListener('ended', props.onAudioEnded);
        return function () { return audioRef.current.removeEventListener('ended', props.onAudioEnded); };
    }, []);
    (0, react_1.useEffect)(function () {
        // Simulate an autoplay by playing every voice messages of a single message group one after the other
        if (props.file.autoPlay && props.shouldPlay) {
            void audioRef.current.play();
        }
    }, [props.file.autoPlay, props.shouldPlay]);
    if (!props.file) {
        return null;
    }
    var audio = props.file.audio;
    var extension = path_1.default.extname(audio);
    var mime = lite_1.default.getType(extension);
    return (react_1.default.createElement("audio", { controls: true, ref: audioRef },
        react_1.default.createElement("source", { src: audio, type: mime })));
};
exports.VoiceMessage = VoiceMessage;
